import { FLEETCOR } from "./affiliations";

export const PROJECT_NAME = "Small Fleet OnBoarding";
export const SECTION = "section";
export const PLAYSTORE = "playstore";
export const APPSTORE = "appstore";
export const DEFAULT_COUNTRY = "US";
export const HELPLINE_CONTACT = "(888) 353-3899";

export const FLEET_URL = "https://app.development.fleetadvise.com/";

export const APP_LINK = {
  [`${FLEETCOR}_${PLAYSTORE}`]:
    "https://play.google.com/store/apps/details?id=com.caradvise.fuelman",
  [`${FLEETCOR}_${APPSTORE}`]:
    "https://apps.apple.com/us/app/fuelman-maintenance/id1610375791",
};

export const GENERIC_ERROR_MESSAGE = "Something went wrong!";

export const FUELMAN_DEV = "https://app.development.fuelmanmaintenance.com/";
export const FUELMAN_PROD = "https://app.fuelmanmaintenance.com/";
export const DEVELOPMENT = "development";
export const NA = "N/A";
export const START = "start";
export const LAST = "last";
export const DEFAULT_LANGUAGE = "en";
